var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VTextField',_vm._g(_vm._b({class:_vm.$attrs.class,on:{"change":function($event){return _vm.$emit('change')},"update:error":function($event){return _vm.$emit('errorUpdate', $event)}}},'VTextField',_vm.allBindings,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }